/* Fiche produit TIPSY. — sélecteur « Modèle : Femme / Homme » (17/10/2026).

   La bascule de galerie est faite en CSS (tipsy-pdp-gallery lit le groupe
   radio par :has()). Ce script ajoute seulement :
   1. la mémoire du choix d'une fiche à l'autre (localStorage) ;
   2. au clic sur Femme / Homme, la galerie affichée se cale sur la photo 2,
      la première photo studio (la couverture étant commune aux deux jeux,
      rester dessus ne montrerait aucun changement), et la page remonte
      jusqu'à la galerie, sous le header collant — toujours sur mobile, sur
      desktop seulement si la galerie est hors de vue (18/10/2026) ;
 */
(() => {
  const KEY = 'tipsyGender';
  const radios = () => Array.from(document.querySelectorAll('[data-tpg-gender]'));
  if (!radios().length) return;

  const save = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {}
  };

  const read = () => {
    try {
      return localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  };

  const gallery = (set) => document.querySelector(`tipsy-pdp-gallery[data-tpg-set="${set}"]`);

  // Montre la photo 2 : la première photo studio du jeu choisi.
  const showStudio = (g) => {
    if (!Number(g.dataset.tpgStudio || 0)) return;
    const input = g.querySelector('[data-tpg-state][data-tpg-index="2"]');
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  // Hauteur du header collant d'Horizon (section du groupe header).
  const headerHeight = () => {
    const h = document.querySelector('.header-section');
    if (!h || !['sticky', 'fixed'].includes(getComputedStyle(h).position)) return 0;
    return h.getBoundingClientRect().height;
  };

  const mobile = () => window.matchMedia('(max-width: 55.999rem)').matches;

  // Amène le haut de la galerie juste sous le header. Sur desktop, seulement
  // si elle n'est pas déjà visible.
  const revealGallery = (g) => {
    const top = g.getBoundingClientRect().top;
    const offset = headerHeight() + 8;
    if (!mobile()) {
      const bottom = g.getBoundingClientRect().bottom;
      if (bottom > offset && top < window.innerHeight) return;
    }
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, window.scrollY + top - offset), behavior: reduce ? 'instant' : 'smooth' });
  };

  // Rétablit le choix mémorisé si le script en ligne n'a pas pu le faire.
  const stored = read();
  if (stored === 'homme' || stored === 'femme') {
    radios().forEach((r) => {
      if (r.value === stored && !r.checked) r.checked = true;
    });
  }

  document.addEventListener('change', (event) => {
    const r = event.target;
    if (!(r instanceof HTMLInputElement) || !r.hasAttribute('data-tpg-gender') || !r.checked) return;
    save(r.value);
  });

  // `click` et non `change` : un clic sur le genre déjà choisi doit aussi
  // ramener la galerie. Le clic (souris, doigt, clavier) vient toujours de
  // l'utilisateur ; le rétablissement ci-dessus n'en émet aucun.
  document.addEventListener('click', (event) => {
    const r = event.target;
    if (!(r instanceof HTMLInputElement) || !r.hasAttribute('data-tpg-gender') || !r.checked) return;
    const g = gallery(r.value);
    if (!g || g.offsetParent === null) return;
    showStudio(g);
    revealGallery(g);
  });

})();
